import type { HydrateEnrollmentSessionFn } from '../../types'
import {
  getSignatureStatus,
  hasSignedEnrollmentAgreement,
  shouldRestartSigningFlow
} from '../../utils/utils'

type RefreshDocusignSignatureStatusArgs = {
  enrollmentSessionToken: string
  hydrateEnrollmentSession: HydrateEnrollmentSessionFn
  handleOpenDocusignModal: () => Promise<void>
  isRestartingDocusignRef: { current: boolean }
  setSignatureStatus: (value: string | null) => void
  setIsFinalizingDocusign: (value: boolean) => void
  setIsDocusignIframeLoading: (value: boolean) => void
  completeSigningFlow: () => Promise<void>
}

export async function refreshDocusignSignatureStatus({
  enrollmentSessionToken,
  hydrateEnrollmentSession,
  handleOpenDocusignModal,
  isRestartingDocusignRef,
  setSignatureStatus,
  setIsFinalizingDocusign,
  setIsDocusignIframeLoading,
  completeSigningFlow
}: RefreshDocusignSignatureStatusArgs) {
  if (!enrollmentSessionToken) {
    return false
  }

  const state = await hydrateEnrollmentSession(false)

  if (!state) {
    return false
  }

  const status = getSignatureStatus(state)
  const signed = hasSignedEnrollmentAgreement(state)
  const shouldRestart = shouldRestartSigningFlow(state)

  setSignatureStatus(status)

  if (shouldRestart && !isRestartingDocusignRef.current) {
    isRestartingDocusignRef.current = true
    setIsFinalizingDocusign(false)
    setIsDocusignIframeLoading(true)
    void handleOpenDocusignModal()
    return false
  }

  if (signed) {
    await completeSigningFlow()
  }

  return signed
}
